module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"coach_mark_message":"Swipe up to see <br /> <b>more reviews</b>","coach_mark_message_pc":"Scroll the mouse or use the keyboard arrow keys ⬆️⬇️<br />to check <b>more reviews</b>.","see_more_reviews":"Browse reviews"}}')
  delete Component.options._Ctor
}
